// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderStyles } from "@insite/content-library/Widgets/Basic/QuickOrder";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { getSystemColor, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

quickOrderStyles.container = {
    offsetCss: css`
        margin-bottom: 16px;
    `,
};

quickOrderStyles.productSelector = {
    container: { gap: 10 },
    searchGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            position: relative;
        `,
    },
    qtyGridItem: { width: [6, 3, 2, 2, 2] },
    unitOfMeasureGridItem: { width: [6, 4, 2, 2, 2] },
    buttonGridItem: {
        width: [12, 5, 3, 3, 3],
        css: css`
            justify-content: flex-end;
            align-items: flex-end;
        `,
    },
    selectButton: {
        css: css`
            &&& {
                min-height: 37px;
                margin-top: 0;
                margin-bottom: 0;
            }
            ${xScreen("lte", "xs")} {
                &&& {
                    margin-top: 21px;
                    width: 100%;
                }
            }
        `,
    },
    clearIcon: {
        size: 18,
        css: css`
            position: absolute;
            right: 35px;
            top: 35px;
            cursor: pointer;
        `,
    },
};

quickOrderStyles.titleGridItem = {
    width: [12, 12, 5, 5, 5],
    css: css`
        padding-bottom: 0;
    `,
};
quickOrderStyles.titleText = {
    variant: "h3",
    color: "text.main",
    css: css`
        margin-bottom: 0;
        ${xScreen("lte", "sm")} {
            margin-bottom: 12px;
        }
    `,
};

quickOrderStyles.linksGridItem = {
    width: [12, 12, 7, 7, 7],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-bottom: 0;
                    padding-top: 0;
                `,
                css`
                    padding-bottom: 0;
                    padding-top: 0;
                `,
                css`
                    padding-bottom: 0;
                    justify-content: flex-end;
                    padding-top: 20px;
                `,
                css`
                    padding-bottom: 0;
                    justify-content: flex-end;
                    padding-top: 20px;
                `,
                css`
                    padding-bottom: 0;
                    justify-content: flex-end;
                    padding-top: 20px;
                `,
            ])}
    `,
};

quickOrderStyles.orderUploadLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        css: css`
            letter-spacing: 0;
            line-height: 17px;
        `,
    },
};
quickOrderStyles.orderMultipleItemsLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        css: css`
            letter-spacing: 0;
            line-height: 17px;
        `,
    },
    css: css`
        margin-left: 20px;
    `,
};
